import React from "react";
import "./CustomPagination.css";

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
    const handlePageClick = (page) => {
        if (page !== currentPage && page > 0 && page <= totalPages) {
            onPageChange(page);
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const maxButtons = 5; // 최대 버튼 개수
        const half = Math.floor(maxButtons / 2);

        let start = Math.max(1, currentPage - half);
        let end = Math.min(totalPages, currentPage + half);

        // 페이지 버튼이 부족할 경우 시작/끝 페이지 보정
        if (end - start + 1 < maxButtons) {
            if (currentPage <= half) {
                end = Math.min(totalPages, start + maxButtons - 1);
            } else if (currentPage + half >= totalPages) {
                start = Math.max(1, end - maxButtons + 1);
            }
        }

        for (let i = start; i <= end; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    onClick={() => handlePageClick(i)}
                    className={`pagination-number ${currentPage === i ? "active" : ""}`}
                >
                    {i}
                </button>
            );
        }
        return pageNumbers;
    };

    return (
        <div className="pagination-container">
            <button
                onClick={() => handlePageClick(1)}
                disabled={currentPage === 1}
                className="pagination-btn"
            >
                {"<<"}
            </button>
            <button
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
                className="pagination-btn"
            >
                {"<"}
            </button>

            {/* 페이지 번호 버튼 렌더링 */}
            {renderPageNumbers()}

            <button
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="pagination-btn"
            >
                {">"}
            </button>
            <button
                onClick={() => handlePageClick(totalPages)}
                disabled={currentPage === totalPages}
                className="pagination-btn"
            >
                {">>"}
            </button>
        </div>
    );
};

export default CustomPagination;
